import { render, staticRenderFns } from "./ProvisionedOrdersView.vue?vue&type=template&id=4e0f18a7&scoped=true"
import script from "./ProvisionedOrdersView.vue?vue&type=script&lang=js"
export * from "./ProvisionedOrdersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f18a7",
  null
  
)

export default component.exports